export const FEATURE_FLAGS = {
  // TODO: Will be activated in https://quick.atlassian.net/browse/Q2-727
  vehicleType: false,
  unknownWeight: false,
  // TODO: Always allow and remove after fix in https://quick.atlassian.net/browse/Q2-1464
  allowMetric: true,
};
